export default {
  filterData : {
    Products: {
      label: '产品',
      allFilterLabel: "全部产品",
      items: [
        { name: "Citrix ADC", id: "citrix_adc" },
        { name: "Citrix Analytics for Performance", id: "citrix_analytics_for_performance" },
        { name: "Citrix Analytics for Security", id: "citrix_analytics_for_security" },     
        { name: "Citrix App Delivery and Security Service", id:"citrix_app_delivery_and_security_service"},
        { name: "Citrix Application Delivery Management", id: "citrix_application_delivery_management" },
        { name: "Citrix Content Collaboration", id: "citrix_content_collaboration" },
        { name: "Citrix DaaS (formerly Citrix Virtual Apps and Desktops service)", id: "citrix_virtual_apps_and_desktops" },
        {
          name: "Citrix DaaS Standard for Azure",
          id: "citrix_virtual_apps_and_desktops_standard_for_azure"
        },
        {
          name: "Citrix DaaS Standard for Google Cloud",
          id: "citrix_daas_standard_for_google_cloud",
        },
        { name: "Citrix Endpoint Management", id: "citrix_endpoint_management" },
        { name: "Citrix Gateway", id: "citrix_gateway" },
        { name: "Citrix SD-WAN", id: "citrix_sd_wan" },
        { name: "Citrix Secure Internet Access", id: "citrix_secure_internet_access" },
        { name: "Citrix Secure Private Access", id: "citrix_secure_private_access" },
        { name: "Citrix Virtual Apps and Desktops", id: "citrix_virtual_apps_desktops" },
        { name: "Citrix Web App and API Protection", id: "citrix_web_app_and_api_protection" },
        { name: "Citrix Workspace", id: "citrix_workspace" },
      ],
    },
    Topics: {
      label: "主题",
      allFilterLabel: "所有主题",
      items: [
        { name: "访问管理", id: "Access management" },
        { name: "分析和监控", id: "Analytics and monitoring" },
        { name: "应用交付和安全", id: "Application delivery and security" },
        { name: "Citrix 和 Google", id: "Citrix and Google" },
        { name: "Citrix 和 Microsoft", id: "Citrix and Microsoft" },
        { name: "云迁移", id: "Cloud migration" },
        { name: "对比", id: "Compare" },
        { name: "内容协作", id: "Content collaboration" },
        { name: "数字化工作空间", id: "Digital workspaces" },
        { name: "员工体验", id: "Employee experience" },
        { name: "混合云", id: "Hybrid cloud" },
        { name: "混合办公", id: "Hybrid work" },
        { name: "管理和优化", id: "Manage and optimize" },
        { name: "微服务和 devOps", id: "Microservices and devOps" },
        { name: "用户引导和采用", id: "Onboarding and adoption" },
        { name: "合作伙伴集成", id: "Partner integrations" },
        { name: "产品概述", id: "Product overview" },
        { name: "安全和合规性", id: "Security and compliance" },
        { name: "小企业", id: "Small business" },
        { name: "规格", id: "Specifications" },
        { name: "可持续发展", id: "Sustainability" },
        { name: "统一端点管理", id: "Unified endpoint management" },
        { name: "VDI 和 DaaS", id: "VDI and DaaS" },
      ],
    }, 
    Type: {
      label: '类型',
      allFilterLabel: "所有类型",
      items: [
        { name: "分析报告", id: "Analyst report" },
        { name: "评估工具", id: "Assessment tool" },
        { name: "客户案例", id: "Customer story" },
        { name: "数据表", id: "Data sheet" },
        { name: "演示", id: "Demo" },
        { name: "电子书", id: "eBook" },
        { name: "指南", id: "Guide" },
        { name: "信息图表", id: "Infographic" },
        { name: "交互之旅", id: "Interactive tour" },
        { name: "播客", id: "Podcast" },
        { name: "资源套件", id: "Resource kit" },
        { name: "解决方案简介", id: "Solution brief" },
        { name: "技术简报", id: "Technical brief" },
        { name: "视频", id: "Video" },
        { name: "网络研讨会", id: "Webinar" },
        { name: "白皮书", id: "White paper" },
      ],
    },
    Industry: {
      label: "行业",
      allFilterLabel: "所有行业",
      items: [
        { name: "教育", id: "education" },
        { name: "金融服务", id: "financial_service" },
        { name: "政府", id: "government" },
        { name: "医疗行业", id: "healthcare" },
        { name: "制造行业", id: "manufacturing" },
        { name: "零售", id: "retail" }
      ],
    }
  },
    searchPlaceholder: "搜索库",
    titles : {
      label1: "当前趋势",
      label2: "最新资源",
      label3: "最近查看",
      label4: "推荐资源"
    },
    showMoreLabel: "显示更多",
    clearAllSelected: "清除所有已选项",
    searchResults: "针对以下内容的搜索结果",
    clearAllFilters: "清除所有筛选项",
    noResultsFound: "没有符合您所选条件的资产",
    resetView: "重置视图",
    filterLabel: "筛选器",
    filteredRes: "筛选结果",
    filterRes: "筛选您的结果",
    clearAllCta: "全部清除",
    applyCta: "应用",
    view: "查看",
    includeEnglishRes: "包括英语资源"
  };